// extracted by mini-css-extract-plugin
module.exports = {"container":"PageLinks_container__OcAJs","left":"PageLinks_left__HiBKK","right":"PageLinks_right__d6ABK"};